// setScrollerPositionData.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set scroller position data
 * @kind action
 * @param {object} {scrollerPositionData} - scroller position data Ex: scrollTop.
 * @param {string} {page} - where is the scroller.
 * @return {Promise} Action promise.
 */
const setScrollerPositionData =
  ({ scrollerPositionData, page }) =>
  async dispatch => {
    const selectPath = ['scroller'];
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath,
        data: {
          [page]: {
            ...scrollerPositionData,
          },
        },
      },
    });
  };

export default setScrollerPositionData;
